<template>
  <div class="editMenuBtn">
    <!--新增-->
    <el-dialog
      :title="$t('menu.updateBtnTitle')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="460px"
    >
      <el-form
        label-width="auto"
        :rules="rules"
        :model="addButtonList"
        ref="addButtonList"
        :label-position="'right'"
      >
        <el-form-item :label="$t('menu.menuName')" prop="buttonName">
          <el-input
            v-model="addButtonList.buttonName"
            :placeholder="$t('menu.namePlaceholder')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('menu.buttonUrl')" prop="buttonUrl">
          <el-input
            v-model="addButtonList.buttonUrl"
            :placeholder="$t('menu.buttonUrlPlaceholder')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('menu.buttonStyle')" prop="buttonStyle">
          <el-input
            v-model="addButtonList.buttonStyle"
            :placeholder="$t('menu.buttonStylePlaceholder')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('menu.sortNo')" prop="sortNo">
          <el-input-number
            v-model="addButtonList.sortNo"
            :placeholder="$t('menu.sortPlaceholder')"
            controls-position="right"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('menu.remark')" prop="remark">
          <el-input
            v-model="addButtonList.remark"
            :placeholder="$t('menu.remarkPlaceholder')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('menu.buttonType')" prop="doubleClickFlag">
          <el-select v-model="addButtonList.doubleClickFlag" filterable>
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用范围" prop="buttonLocation">
          <el-select
            v-model="addButtonList.buttonLocation"
            placeholder="请选择使用范围"
            style="width: 100%"
            filterable
          >
            <el-option label="列表" value="list"></el-option>
            <el-option label="其他" value="other"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用权限" prop="authCode">
          <el-input v-model="addButtonList.authCode" disabled clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
        <el-button @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from '@/api/systemManage/menu.js';
  export default {
    name: 'addMenuBtn',
    data() {
      return {
        loading: false,
        dialogAdd: false,
        addButtonList: {
          buttonName: '', //名称
          buttonUrl: '', //方法
          buttonStyle: '', //图标样式
          sortNo: '', //排序
          remark: '', //备注
          doubleClickFlag: '', //0:普通按钮 1:双击 2:单击
        },
        options: [
          { value: 0, label: '普通按钮' },
          { value: 1, label: '双击(表格)' },
          { value: 2, label: '单击(树)' },
        ],
      };
    },
    computed: {
      rules() {
        // 校验特殊字符
        var specialValidate = (rule, value, callback) => {
          var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          if (value.match(reg)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else {
            callback();
          }
        };
        return {
          buttonName: [
            {
              required: true,
              message: this.$t('menu.menunameNotEmpty'),
              trigger: 'blur',
            },
            {
              min: 1,
              max: 40,
              message: this.$t('menu.menunameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          buttonUrl: [
            {
              required: true,
              message: this.$t('menu.buttonUrlNotEmpty'),
              trigger: 'blur',
            },
            {
              min: 1,
              max: 40,
              message: this.$t('menu.menunameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          buttonStyle: [
            {
              min: 1,
              max: 40,
              message: this.$t('menu.menunameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          sortNo: [
            {
              required: true,
              message: this.$t('menu.sortNoNotEmpty'),
              trigger: 'blur',
            },
          ],
          remark: [
            {
              min: 1,
              max: 400,
              message: this.$t('menu.remarkWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          buttonLocation: [
            {
              required: true,
              message: '请选择使用范围',
              trigger: 'blur',
            },
          ],
        };
      },
    },
    methods: {
      openDialog(flag, menu) {
        if (this.$refs['addButtonList']) {
          this.$refs['addButtonList'].resetFields();
        }
        this.addButtonList = menu;
        this.dialogAdd = flag;
      },
      //保存
      addSure() {
        this.$refs.addButtonList.validate((valid) => {
          if (valid && !this.loading) {
            this.loading = true;
            delete this.addButtonList.gmtCreate;
            delete this.addButtonList.gmtModified;
            this.$axios.post(API.UPDATE_MENU_BTN_API, this.addButtonList).then((res) => {
              this.loading = false;
              if (0 != res.data.code) {
                this.$alert(res.data.msg);
              } else {
                this.dialogAdd = false;
                this.$emit('getListData');
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>
